// frontend/admin-portal/src/components/products/ProductSpecsTable.jsx
import React from "react";
import { Card } from "@fiberhome/shared-ui";

function normalizeSchema(schema) {
  if (Array.isArray(schema)) return schema;
  if (typeof schema === "string") {
    try {
      const parsed = JSON.parse(schema);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  if (schema && typeof schema === "object") {
    return Object.values(schema).filter((v) => v && typeof v === "object");
  }
  return [];
}

function normalizeAttributes(attrs) {
  if (!attrs) return {};
  if (typeof attrs === "string") {
    try {
      return JSON.parse(attrs) || {};
    } catch {
      return {};
    }
  }
  return typeof attrs === "object" ? attrs : {};
}

export default function ProductSpecsTable({ category, attributes }) {
  const schema = normalizeSchema(category?.attributeSchema);
  const values = normalizeAttributes(attributes);

  // Show every schema field, plus any orphan attributes the user set previously
  const schemaKeys = new Set(schema.map((f) => f.key));
  const orphans = Object.keys(values).filter((k) => !schemaKeys.has(k));

  const rows = [
    ...schema.map((f) => ({
      key: f.key,
      label: f.unit ? `${f.label} (${f.unit})` : f.label,
      value: values[f.key],
    })),
    ...orphans.map((k) => ({ key: k, label: k, value: values[k] })),
  ].filter((r) => r.value !== undefined && r.value !== null && r.value !== "");

  if (rows.length === 0) {
    return (
      <Card title="Specifications">
        <div className="text-muted" style={{ fontSize: 13 }}>
          No specifications recorded for this product.
        </div>
      </Card>
    );
  }

  return (
    <Card title="Specifications">
      <div className="fh-specs-grid">
        {rows.map((row) => (
          <div key={row.key} className="fh-spec-row">
            <div className="fh-spec-label">{row.label}</div>
            <div className="fh-spec-value">{String(row.value)}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
